import {AsyncActionState} from '@telstra-connect/standard-actions/async-action'
import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  ILoadServiceDetailsAction,
  ILoadServiceDetailsSuccessAction,
  ILoadServiceDetailsErrorAction,
} from '../actions/load-service-details'
import {IMobilityState} from '../state'
import {initialState} from '../state/initial-state'

export type LoadServiceDetailsAction =
  | ILoadServiceDetailsAction
  | ILoadServiceDetailsSuccessAction
  | ILoadServiceDetailsErrorAction

const init = (state: IMobilityState, action: LoadServiceDetailsAction) => ({
  ...state,
  serviceDetails: {
    ...initialState.serviceDetails,
    status: action.status,
    data: null,
  },
})

const success = (state: IMobilityState, action: LoadServiceDetailsAction) => ({
  ...state,
  serviceDetails: {
    ...initialState.serviceDetails,
    status: action.status,
    data: (action as ILoadServiceDetailsSuccessAction).data,
    payload: (action as ILoadServiceDetailsSuccessAction).payload,
  },
})

const reset = (state: IMobilityState) => ({
  ...state,
  serviceDetails: {
    ...initialState.serviceDetails,
    status: AsyncActionState.NotStarted,
    data: null,
    error: null,
  },
})

const failure = (state: IMobilityState, action: LoadServiceDetailsAction) => ({
  ...state,
  serviceDetails: {
    ...initialState.serviceDetails,
    status: action.status,
    error: (action as ILoadServiceDetailsErrorAction).error,
    code: (action as ILoadServiceDetailsErrorAction).code,
  },
})

export const loadServiceDetailsReducer = createAsyncReducer(
  initialState,
  init,
  success,
  failure,
  reset,
)
